import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';

import { ListingSectionObservable } from '../ListingSection';
import ListingDescription from '../ListingDescription';

import './ListingDescriptionSimplified.scss';

const COLLAPSIBLE_CHAR_LIMIT = 200;

const ListingDescriptionSimplified = ({
  description = '',
  landlordDescription = ''
}) => {
  if (!description && !landlordDescription) {
    return null;
  }

  return (
    <ListingSectionObservable section="listingDescription" bordered={false}>
      <ListingTitle role="secondary">
        {trans('listing.value.proposition.title')}
      </ListingTitle>
      {description && (
        <ListingDescription
          className="listing-description-simplified__item"
          title={trans('listing.overview.description.title')}
          description={description}
          collapsible={description.length > COLLAPSIBLE_CHAR_LIMIT}
          titleRole="tertiary"
        />
      )}
      {landlordDescription && (
        <ListingDescription
          className="listing-description-simplified__item"
          title={trans('listing.overview.landlord.description.title')}
          description={landlordDescription}
          collapsible={landlordDescription.length > COLLAPSIBLE_CHAR_LIMIT}
          titleRole="tertiary"
        />
      )}
    </ListingSectionObservable>
  );
};

ListingDescriptionSimplified.propTypes = {
  description: PropTypes.string,
  landlordDescription: PropTypes.string
};

export default ListingDescriptionSimplified;
